import { money } from "@/lib/format";
import type { Summary } from "@/lib/types";
import Icon3D from "@/components/base/Icon3D";

interface Stat {
  label: string;
  value: number;
  icon: string;
  tone: "secondary" | "accent" | "primary" | "neutral";
}

const toneMap: Record<Stat["tone"], string> = {
  secondary: "bg-secondary-100 text-secondary-700",
  accent: "bg-accent-100 text-accent-800",
  primary: "bg-primary-100 text-primary-700",
  neutral: "bg-background-200 text-foreground-600",
};

export default function StatGrid({ summary }: { summary: Summary }) {
  const stats: Stat[] = [
    { label: "Dinero en ventas", value: summary.salesIncome, icon: "ri-shopping-bag-3-line", tone: "primary" },
    { label: "Gastado en compras", value: summary.purchaseSpend, icon: "ri-shopping-cart-2-line", tone: "secondary" },
    { label: "Ganancia bruta", value: summary.grossProfit, icon: "ri-line-chart-line", tone: "accent" },
    { label: "Gastos adicionales", value: summary.extraExpenses, icon: "ri-wallet-3-line", tone: "neutral" },
    { label: "Recuperado por devoluciones", value: summary.refundsRecovered, icon: "ri-refund-2-line", tone: "secondary" },
    { label: "Valor del inventario", value: summary.inventoryValue, icon: "ri-stack-line", tone: "accent" },
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="rounded-3xl border border-background-200/70 bg-background-50 p-3.5 shadow-card"
        >
          <div className={`flex h-8 w-8 items-center justify-center rounded-xl ${toneMap[stat.tone]}`}>
            <Icon3D icon={stat.icon} tone={stat.tone} size={19} />
          </div>
          <p className="tabular-nums mt-2 text-[17px] font-semibold text-foreground-950">
            {money(stat.value, summary.currency)}
          </p>
          <p className="mt-0.5 text-[11px] leading-tight text-foreground-500">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}